document.addEventListener('DOMContentLoaded', () => {
  const storeDataElement = document.getElementById('store-locator-data');
  if (!storeDataElement) return;

  let stores = [];
  try {
    stores = JSON.parse(storeDataElement.textContent);
  } catch (e) {
    console.error('Failed to parse store locator data');
    return;
  }

  const searchInput = document.getElementById('store-locator-search');
  const form = document.getElementById('store-locator-form');
  const resultsContainer = document.getElementById('store-locator-results');
  const errorContainer = document.getElementById('store-locator-error');
  const emptyText = resultsContainer.dataset.emptyText || 'No results found.';

  let searchTimeout = null;

  const EARTH_RADIUS_MILES = 3958.8;

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const toRadians = (deg) => deg * (Math.PI / 180);
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
      
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_MILES * c;
  }

  function renderStoreCard(store, distance = null, index = 0) {
    let cleanPhone = '';
    if (store.phone) {
      // Remove all non-numeric characters for the tel: link
      const digits = String(store.phone).replace(/\D/g, '');
      // Auto-add +1 if it's a 10-digit US number
      cleanPhone = digits.length === 10 ? `+1${digits}` : `+${digits}`;
    }

    const phoneHtml = store.phone 
      ? `<a href="tel:${cleanPhone}" class="store-card-phone">
           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
           ${store.phone}
         </a>` 
      : '';
      
    let websiteUrl = '';
    if (store.website) {
      if (Array.isArray(store.website)) {
        websiteUrl = store.website[0] || ''; // Handle List of URLs
      } else if (typeof store.website === 'object') {
        // Handle Shopify Link field or generic object
        websiteUrl = store.website.url || store.website.value || store.website.href || '';
      } else {
        websiteUrl = String(store.website); // Handle plain string
      }
      
      // Ensure absolute URL
      if (websiteUrl && !websiteUrl.startsWith('http') && !websiteUrl.startsWith('/')) {
        websiteUrl = 'https://' + websiteUrl;
      }
    }

    const websiteHtml = store.website 
      ? `<a href="${websiteUrl || '#'}" target="_blank" rel="noopener" class="store-card-btn">
           Visit Website
           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
         </a>` 
      : '';
    
    const distanceHtml = distance !== null 
      ? `<div class="store-card-distance">
           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
           ${distance.toFixed(1)} mi away
         </div>`
      : '';

    const badgeClass = store.store_type ? `store-card-badge store-card-badge--${store.store_type.toLowerCase().replace(/\s+/g, '-')}` : 'store-card-badge';
    const badgeHtml = store.store_type 
      ? `<span class="${badgeClass}">${store.store_type}</span>`
      : '';

    // Media priority: storefront image first, logo as fallback, then placeholder.
    let mediaHtml;
    if (store.image) {
      mediaHtml = `<img src="${store.image}" alt="${store.name} storefront" class="store-card-image" loading="lazy">`;
    } else if (store.logo) {
      mediaHtml = `<img src="${store.logo}" alt="${store.name} logo" class="store-card-image store-card-image--logo" loading="lazy">`;
    } else {
      mediaHtml = `<div class="store-card-image-placeholder">
           <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity: 0.2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
         </div>`;
    }

    // Google Maps link, in priority order:
    // 1. A manual maps_url override (paste a Maps share link per store when the auto pin is off).
    // 2. Business name + address, so Google matches the real business listing (more accurate than raw coords).
    // 3. Raw coordinates as a last resort.
    let mapsUrl = '';
    if (store.maps_url) {
      mapsUrl = String(store.maps_url);
    } else {
      let mapsQuery = '';
      if (store.name && store.address) {
        mapsQuery = `${store.name}, ${store.address}, ${store.city}, ${store.state} ${store.zip}`;
      } else if (store.latitude && store.longitude) {
        mapsQuery = `${store.latitude},${store.longitude}`;
      }
      if (mapsQuery) {
        mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapsQuery)}`;
      }
    }

    const mapHintHtml = `
      <span class="store-card-map-hint">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
        View on map
      </span>`;

    const mediaWrapped = mapsUrl
      ? `<a href="${mapsUrl}" target="_blank" rel="noopener" class="store-card-image-link" aria-label="Open ${store.name} location in Google Maps">${mediaHtml}${mapHintHtml}</a>`
      : mediaHtml;

    const delay = Math.min(index * 40, 400); // Cap stagger delay

    return `
      <div class="store-card" style="animation-delay: ${delay}ms">
        <div class="store-card-image-wrapper">
          ${mediaWrapped}
        </div>
        <div class="store-card-content">
          <div class="store-card-header">
            <div class="store-card-header-text">
              <h3 class="store-card-title">${store.name}</h3>
              <div class="store-card-badges">
                ${badgeHtml}
                ${distanceHtml}
              </div>
            </div>
          </div>
          <div class="store-card-body">
            <div class="store-card-address">
              <p class="store-card-street">${store.address}</p>
              <p class="store-card-city">${store.city}, ${store.state} ${store.zip}</p>
            </div>
            ${phoneHtml}
          </div>
          ${websiteHtml ? `<div class="store-card-footer">${websiteHtml}</div>` : ''}
        </div>
      </div>
    `;
  }

  function displayResults(results, withDistance = false) {
    if (results.length === 0) {
      resultsContainer.innerHTML = `<p class="store-locator-empty">${emptyText}</p>`;
      return;
    }

    const html = results.map((store, index) => {
      return renderStoreCard(store, withDistance ? store.distance : null, index);
    }).join('');

    resultsContainer.innerHTML = html;
  }

  async function handleSearch(e) {
    if (e && e.preventDefault) e.preventDefault();
    
    errorContainer.hidden = true;
    const query = searchInput.value.toLowerCase().trim();
    
    if (!query) {
      displayResults(stores);
      return;
    }

    if (/^\d{5}$/.test(query)) {
      resultsContainer.innerHTML = '<div class="store-locator-loading">Searching...</div>';
      try {
        const response = await fetch(`https://api.zippopotam.us/us/${query}`);
        if (!response.ok) {
          throw new Error('ZIP code not found');
        }
        
        const data = await response.json();
        const originLat = parseFloat(data.places[0].latitude);
        const originLon = parseFloat(data.places[0].longitude);

        const storesWithDistance = stores.reduce((acc, store) => {
          if (store.latitude && store.longitude) {
            const distance = calculateDistance(originLat, originLon, store.latitude, store.longitude);
            acc.push({ ...store, distance });
          } else {
            console.warn(`Store missing coordinates: ${store.name}`);
          }
          return acc;
        }, []);

        storesWithDistance.sort((a, b) => a.distance - b.distance);
        displayResults(storesWithDistance, true);

      } catch (err) {
        errorContainer.textContent = 'Invalid ZIP code or service unavailable. Please try another ZIP.';
        errorContainer.hidden = false;
        resultsContainer.innerHTML = '';
      }
    } else {
      const filtered = stores.filter(store => {
        const nameMatch = store.name && store.name.toLowerCase().includes(query);
        const cityMatch = store.city && store.city.toLowerCase().includes(query);
        const stateMatch = store.state_code && store.state_code.toLowerCase().includes(query);
        return nameMatch || cityMatch || stateMatch;
      });

      displayResults(filtered);
    }
  }

  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(handleSearch, 400);
  });

  form.addEventListener('submit', handleSearch);

  displayResults(stores);
});
